import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_VEHICLES_VALIDATION_LIST = {
  'data': [],
  'loading': false,
};

export const vehiclesValidation = (state, action) => {
  return createReducer(INITIAL_STATE_VEHICLES_VALIDATION_LIST, {
    [ActionTypes.FETCHING_VEHICLES_VALIDATION_LIST]: (state, action) => ({
      ...state,
      'loading': true,
      'data': [],
    }),
    [ActionTypes.FETCHED_VEHICLES_VALIDATION_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'data': [],
    }),
    [ActionTypes.FETCHED_VEHICLES_VALIDATION_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'data': action.response.data,
    }),
    [ActionTypes.SENDING_VEHICLES_ACC_TRANSFER]: (state, action) => ({
      ...state,
      'loading': true,
      'data': [],
    }),
    [ActionTypes.SENDED_VEHICLES_ACC_TRANSFER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SENDED_VEHICLES_ACC_TRANSFER]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
